// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3snOG","empty":"ModalGraph_empty__r0mHb"};